export default __webpack_public_path__ + "static/media/1007.28e98b7e.png";